<template>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <el-menu
      router
      class="border-0 el-menu-vertical-demo animated fadeIn h-100"
      :collapse="this.$store.state.menuIsCollapse"
      background-color="#343a40"
      text-color="#fff"
      active-text-color="#ffd04b"
      unique-opened
    >
      <el-submenu
        v-for="(item, i) in adminMenus"
        :key="i"
        :index="i.toString()"
      >
        <template slot="title">
          <i :class="item.iconCls"></i>
          <span>{{ item.nameZh }}</span>
        </template>
        <el-menu-item
          v-for="child in item.children"
          :key="child.path"
          :index="child.path"
        >
          <i :class="child.iconCls"></i>
          {{ child.nameZh }}
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "AdminMenu",
  data() {
    return {};
  },
  computed: {
    adminMenus() {
      return this.$store.state.adminMenus;
    }
  },
  methods: {}
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  min-width: 240px;
}
</style>
